import VueRouter, { RouteConfig } from 'vue-router'
const PracticeList = () => import('@/views/special-skill/PracticeList.vue')
const TaskList = () => import('@/views/special-skill/TaskList.vue')
const TaskDetail = () => import('@/views/special-skill/TaskDetail.vue')

import specialSkillIcon from '../views/special-skill/assets/icon_special_skill_gray@2x.png'
import specialSkillIconActive from '../views/special-skill/assets/icon_special_skill@2x.png'
import PracticeClazzDetailPage from '../views/special-skill/PracticeClazzDetail.vue'
import PracticeStudentListPage from '../views/special-skill/PracticeStudentList.vue'
import PracticeStudentDetailPage from '@/views/special-skill/PracticeStudentDetail.vue'

const Layout = () => import('../views/Layout.vue')

export const PracticeRoute: RouteConfig = {
  path: '/exam-practice-list-2023',
  name: 'exam_practice_list_2023',
  component: PracticeList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '任务列表',
    showMenu: true,
  },
}

export const TaskRoute: RouteConfig = {
  path: '/exam-task-list',
  name: 'exam_task_list',
  component: TaskList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '训练列表',
    showMenu: true,
  },
}

export const PracticeClazzDetailRoute: RouteConfig = {
  path: '/exam-practice-clazz-detail',
  name: 'exam_practice_clazz_detail',
  component: PracticeClazzDetailPage,
  props: (route) => ({ ...route.query, ...route.params, training: JSON.parse(route.query.training as string) }),
  meta: {
    title: '任务列表',
  },
}

export const PracticeStudentListRoute: RouteConfig = {
  path: '/exam-practice-student-detail',
  name: 'exam_practice_student_list_detail',
  component: PracticeStudentListPage,
  props: (route) => ({
    ...route.query,
    ...route.params,
    ...route.query,
    ...route.params,
    training: JSON.parse(route.query.training as string),
    clazzOptions: JSON.parse(route.query.clazzOptions as string),
    challengeClassId: route.query.challengeClassId,
  }),
  meta: {
    title: '任务列表',
  },
}

export const PracticeStudentDetailRoute: RouteConfig = {
  path: '/winter_2023_question_student_training_record_detail',
  name: 'winter_2023_question_student_training_record_detail',
  component: PracticeStudentDetailPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '个人训练记录',
  },
}

export const TaskDetailRoute: RouteConfig = {
  path: '/exam-task-detail',
  name: 'exam_task_detail',
  component: TaskDetail,
  props: (route) => ({ ...route.query, ...route.params, id: route.query.id }),
  meta: {
    title: '训练列表',
  },
}

export const SpecialSkillRoute: RouteConfig = {
  path: '/exam-or-practice-special-skill',
  name: 'exam_or_practice_special_skill',
  component: Layout,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '专项技能',
    showMenu: true,
    icon: specialSkillIcon,
    iconActive: specialSkillIconActive,
  },
  children: [
    PracticeRoute,
    TaskRoute,
    TaskDetailRoute,
    PracticeClazzDetailRoute,
    PracticeStudentListRoute,
    PracticeStudentDetailRoute,
  ],
}

export default [SpecialSkillRoute]

export function navToTaskDetail(router: VueRouter, id: string, imgUrl: string, from?: string) {
  router.push({ name: TaskDetailRoute.name, query: { id, imgUrl, from } })
}
